/*
  Figma "Avatar": a photo, or initials on fill/secondary. Sizes S 24, M 32, L 48
  with radius/14 corners, and XL 64 with 20.
*/
const SIZES = {
  s: "size-6 text-caption-1",
  m: "size-8 text-caption-1-semibold",
  l: "size-12 text-headline",
  xl: "size-16 !rounded-[20px] text-title-2",
};

export const initialsOf = (name, count = 2) =>
  String(name || "?")
    .replace(/^@/, "")
    .trim()
    .slice(0, count)
    .toUpperCase();

const Avatar = ({ src, name, size = "s", initials, className = "" }) => (
  <span
    className={`relative flex shrink-0 items-center justify-center overflow-hidden rounded-14 bg-fill-secondary text-label-secondary ${SIZES[size]} ${className}`}
    aria-hidden="true"
  >
    {src ? <img src={src} alt="" className="h-full w-full object-cover" /> : initials || initialsOf(name, size === "l" ? 1 : 2)}
  </span>
);

export default Avatar;
